<h3 translate>HANDELSSORTIMENT_DETAIL_PRODUKT_HEADER</h3>
<div class="row">
  <div class="form-group col-4">
    <label class="col-form-label" translate>HANDELSSORTIMENT_DETAIL_HANDELSSORTIMENTPRODUKT_PRODUKT_LABEL</label>
  </div>
  <div class="col-2 groupHeader">
    <label class="col-form-label col-3 groupHeaderItem">Granska</label>
    <label class="col-form-label col-9 groupHeaderItem" translate>HANDELSSORTIMENT_DETAIL_HANDELSSORTIMENTPRODUKT_ANDEL_LABEL</label>
  </div>
  <div class="col-2">
    <label class="col-form-label" translate>HANDELSSORTIMENT_DETAIL_HANDELSSORTIMENTPRODUKT_FORDELNINGSTYP_LABEL</label>
  </div>
  <div class="col-1">
    <label class="col-form-label" translate>HANDELSSORTIMENT_DETAIL_HANDELSSORTIMENTPRODUKT_TA_BORT_LABEL</label>
  </div>

  <div class="col-2">
    <span class="controls">
      <button aid="lagg-till-handelssortiment-produkt" type="button" class="btn btn-tertiary" (click)="addHandelssortimentProdukt()" [disabled]="disabled" translate>{{'HANDELSSORTIMENT_PRODUKT_NY_PRODUKT'}}</button>
    </span>
  </div>
</div>

@for (produkt of produkter; track produkt; let i = $index) {
  <rask-handelssortiment-produkt-rad
    class="row"
    [produkt]="produkt"
    (produktChange)="produktChanged()"
    [validationContext]="validationContext"
    [handelssortimentsgruppId]="handelssortiment.handelssortimentsgruppId"
    (produktRemoved)="removeHandelssortimentProdukt($event)"
    [produkter]="produkter"
    [disabled]="disabled"
    [index]="i"
    >
  </rask-handelssortiment-produkt-rad>
}
